import { loadStripe } from '@stripe/stripe-js'
import type { Stripe } from '@stripe/stripe-js'
import config from '../../../../config/config.json'

let stripePromise: Promise<Stripe | null> | null = null

const handleStripeLoadError = (error: unknown): null => {
  console.warn('Stripe.js failed to load', error)
  return null
}

export default async function getStripePromise(): Promise<Stripe | null> {
  if (!stripePromise) {
    try {
      stripePromise = loadStripe(config.STRIPE_PUBLIC_KEY).catch(handleStripeLoadError)
    } catch (error) {
      handleStripeLoadError(error)
      stripePromise = Promise.resolve(null)
    }
  }

  return await stripePromise
}
